module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_identity.js
// module id = ../../node_modules/ramda/src/internal/_identity.js
// module chunks = 18